export default {
    unassignedOrdersDescription: 'Unscheduled orders are always included.',
    today: 'Today',
    tomorrow: 'Tomorrow',
    last7Days: 'Last 7 Days',
    last2Weeks: 'Last 2 Weeks',
    lastMonth: 'Last Month',
    last3Months: 'Last 3 Months',
    monthToDate: 'Month to date',
    quarterToDate: 'Quarter to date',
    yearToDate: 'Year to date',
    onlyUnassignedOrders: 'Fetch Only Unscheduled',
    selectMode: 'Select Mode',
    selectDateFieldPlaceholder: 'Select a date field...',
    reset: 'Reset',
    selectStatuses: 'Select Status(es)',
    selectDistributionZones: 'Select Terminal(s)',
    selectClients: 'Select Client(s)',
    firebase10Limit: '10 limit',
    distributionZones: 'terminals',
    selectCategories: 'Select Category(ies)',
    selectManufacturers: 'Select Manufacturer(s)',
    customViews: 'Custom Views',
    fetchRecords: 'Fetch Records',
    goToRecords: 'Go to Records',
    goToRoutes: 'Go to Routes',
    goToMapFleet: 'Go to Map & Fleet',
    goToReport: 'Go to Report',
    goToLiveConnect: 'Go to Live Connect',
    goToAdmin: 'Go to Admin',
    openSearch: 'Open Search',
    createDedicatedOrder: 'Create Dedicated Order',
    createSingleOrder: 'Create Single Order',
    openBulkImport: 'Open Bulk Import',
    checkBackLater: 'Check back later for more',
    notApplicable: 'N/A',
    warning: 'Warning',
    language: 'Language',
    'Coming Soon': 'Coming Soon!',
    loadingMessage: 'The Agentic Supply Chain Solution',
    loading: 'Loading...',
    ItemNumber: 'Item Number',
    PrintQuantity: 'Print Quantity',
    internalError: 'Internal Error: Please contact Shyftbase team',
    duplicateEntry: '{{value}} alreday exists. Please enter a different {{field}}',
    login: {
        selectStore: 'Select Store',
        selectRegion: 'Select Region',
        selectRole: 'Select Your Role',
        placeholder: {
            email: 'Email..',
            password: 'Password..',
            verification: 'Please enter your verification code here.',
        },
        rules: {
            title: 'Password must contain:',
            characters: '8 Characters',
            number: 'Contains Number',
            uppercase: 'Contains Uppercase',
            specialCharacters: 'Contains Special Character',
        },
        messages: {
            verification: 'We just sent you a verification code.',
            captchaExpired: 'Session expired. Please attempt again.',
            redirectingToPortal: 'Hang tight, we are redirecting you to the portal.',
            emailVerification: 'Email verification is sent. Please check your inbox.',
            invalidAccount: 'Invalid Account.',
            unsupportedAccess: 'Unsupported access. Please login agian.',
            enterVerficationCode: 'Please enter your verification code.',
            somethingWentWrong: 'Something went wrong. Please try again.',
            standardRate: 'Standard rates may apply.',
            firstTimeLogin: 'Have you made an account before?',
            goBackToLogin: 'Go to login',
            goBackToSignup: 'Go to sign-up',
            createPassword: 'Create a new password',
            confirmPassword: 'Confirm password',
            notMatch: 'Password does not match',
            createAccount: 'Create Account',
        },
        button: {
            submit: 'submit',
            login: 'Log In',
            signup: 'Create your account',
        },
        errorCode: {
            'auth/wrong-password': 'The password is invalid or the user does not have a password.',
            'auth/user-not-found':
                'There is no user record corresponding to this identifier. The user may have been deleted.',
            'auth/invalid-email': 'The email address is badly formatted.',
        },
        twofa: {
            secureAccess: 'Secure Portal',
            sendBtn: 'Send an activation code',
        },
    },
    nav: {
        addOrder: '+ Order',
        search: 'Search',
        orders: 'Orders',
        logout: 'Log Out',
        tooltip: {
            sumamry: 'Today\'s Summary',
            dashboard: 'View your dashboard overview',
            orders: 'Pull records, inventory items, and more',
            mapFleet: 'Manage your hubs, stores, and more',
            report: 'Shyftbase analytics and reports',
            kpis: 'Key Performance Indicators',
            assets: 'SKUs',
            trackOrder: 'Track your orders',
            admin: 'Manage your settings and users',
            help: 'Get help and support',
            history: 'History',
            search: 'Search',
            language: 'Language',
            theme: 'Theme',
            profile: 'Profile',
            today: 'View today\'s summary',
        },
        drawer: {
            handleUiModeMsg: `{{mode}} mode is enabled.`,
            info: 'Info',
            dashboard: 'Dashboard',
            orders: 'Records',
            assets: 'SKUs',
            mapFleet: 'Map Fleet',
            billingModule: 'Billing Module',
            invoice: 'Invoice',
            home: 'Home',
            search: 'Search',
            liveConnect: 'Stores',
            trackOrder: 'Tracking',
            newOrder: 'New Order',
            history: 'History',
            report: 'Analytics',
            kpis: 'KPIs',
            admin: 'Admin',
            logout: 'Logout',
            reverseLogistics: 'Reverse Logistics',
            language: 'Language',
            help: 'Help',
            installations: 'Installations',
            logistics: 'Logistics',
            services: 'Services',
            mode: 'Mode',
            today: 'Today',
            summary: 'Day\'s Summary',
        },
        header: {
            headerTitle: 'Records',
        },
    },
    todaySummary: {
        title: 'Today\'s Summary',
        orders: 'Orders',
        routes: 'Routes'
    },
    dashboard: {
        title: 'Dashboard',
        shyftbaseWatch: 'Shyftbase Watch',
        shyftbaseWatchSubtitle: 'Shyftbase watch activates once enough data is collected',
        shyftbaseWatchModal: {
            title: 'Shyftbase Watch',
            message: 'Shyftbase Watch activates once enough data is collected.',
            buttonText: 'Go to Records Tab',
            closeAriaLabel: 'Close modal',
        },
        operationsOverview: 'Operations Overview',
        orderCount: 'Order Count',
        unconfirmedPercent: 'Unconfirmed %',
        confirmedPercent: 'Confirmed %',
        invoicedPercent: 'Invoiced %',
        activeRoutes: 'Active Routes',
        fleetUtilization: 'Fleet Utilization',
        avgDeliveryTime: 'Avg Delivery Time',
        ordersNeedingAttention: 'Orders needing attention',
        noOrdersNeedAttention: 'No orders currently need attention.',
        noOrdersDescription: 'When you have orders requiring action, they\'ll appear here with details like:',
        noOrdersExamples: {
            addressVerification: 'Address verification needs',
            schedulingConflicts: 'Delivery scheduling conflicts',
            paymentVerification: 'Payment verification pending',
            specialHandling: 'Special handling requirements',
        },
        recommendations: 'Recommendations',
        noRecommendations: 'No recommendations available yet.',
        noRecommendationsDescription: 'As your system collects operational data, AI-powered insights will appear here including:',
        noRecommendationsExamples: {
            routeOptimization: 'Route optimization opportunities',
            capacityPlanning: 'Capacity planning suggestions',
            preventiveMaintenance: 'Preventive maintenance alerts',
            costSaving: 'Cost-saving recommendations',
        },
        quickActions: {
            title: 'Quick Actions',
            orderTable: {
                title: 'Order Table',
                description: 'Live dispatch and ops console',
            },
            uploadCsv: {
                title: 'Upload CSV',
                description: 'Bulk import orders',
            },
            liveConnect: {
                title: 'Live Connect',
                description: 'Approve/reject customer requests',
            },
            mapFleet: {
                title: 'Map Fleet',
                description: 'Monitor fleet & routes',
            },
            search: {
                title: 'Search',
                description: 'Customer support lookups',
            },
            reports: {
                title: 'Reports',
                description: 'Operational insights',
            },
            admin: {
                title: 'Admin',
                description: 'Settings & configuration',
            },
        },
        dataPending: {
            description: 'Operational data will appear here once the system receives orders and processes them.',
        },
    },
    search: {
        title: {
            title: 'You can only search orders that are approved',
            subtitle1: 'To search pending orders, head over to ',
            subtitle2: 'pending orders',
            msg: '* Using date range is recommended for better performance and efficiency',
        },
        label: {
            or: 'Or',
            firstName: 'First Name',
            lastName: 'Last Name',
            phoneNumber: 'Phone Number',
            address: 'Address',
            invoice: 'Type Invoice # and press enter',
            from: 'From (Start Window)',
            to: 'To (Start Window)',
            deliveryDate: 'Delivery Date',
            selectStatus: 'Select Status',
            productName: 'Product Name',
            barcode: 'Barcode',
            whid: 'WHID',
            sku: 'SKU',
            invoiceInput: 'Invoice',
            poNumber: 'PO Number',
            'Scanned In': 'Scanned In',
            'Scanned Out': 'Scanned Out',
        },
        button: {
            reset: 'RESET',
            search: 'SEARCH',
        },
        messages: {
            recordsFound: 'record(s) found',
            noRecordsFound: 'No records found',
            noInputErr: 'Please type at least one keyword to search orders.',
            otherErr: 'Something went wrong. Please contact Shyftbase.',
        },
        'Customer Info': 'Customer Info',
        'Order Details': 'Order Details',
        Statuses: 'Order Statuses',
        Products: 'Products',
        'Reverse Logistics': 'Reverse Logistics',
        'Client Search': 'Client',
        'Zone Search': 'Zone',
        'Minimize Tags': 'Minimize Tags',
        'Show All Tags': 'Show All Tags',
        'Type to show or hide fields': 'Type to show or hide fields',
        'click to show': 'click to show',
        'click to hide': 'click to hide',
        selected: 'selected',
        'Search For Anything': 'Search For Anything',
        'Search Input Placeholder': 'Example: Order #, Customer Name, Client, PO #, Product, Barcode, WHID, SKU',
    },
    liveConnect: {
        orderType: {
            needAttention: 'Need Attention',
            pending: 'Pending (Customer Portal)',
            approved: 'Approved',
            cancelled: 'Cancelled',
            customerRequest: 'Customer Request',
        },
        pageTitle: 'Customer Portal',
        pageDescription: 'View and manage orders from stores for dispatch',
        distributionZone: 'Terminal / Hub',
        region: 'Region',
        store: 'Store',
        invoice: 'Order/Shipmnet Number',
        filter: 'Filter Orders',
        loading: 'Loading Data ...',
        selectDistributionZone: 'Select Terminal/Hub',
        selectStore: 'Select Store',
        invoicePlaceholder: 'Search by order/shipment number...',
        tooltip: {
            distributionZone: 'Filter orders by distribution zone or region',
            store: 'Filter orders by store or vendor',
            invoice: 'Search by invoice number',
            customerRequest: 'Orders where customer has requested a reschedule',
            needAttention: 'Orders that require immediate attention from dispatch',
            pending: 'Orders awaiting processing or approval',
            approved: 'Orders that have been approved and are ready for dispatch',
            cancelled: 'Orders that have been cancelled',
        },
        noOrders: {
            customerRequest: 'No customer reschedule requests',
            needAttention: 'No orders requiring attention',
            pending: 'No pending orders',
            approved: 'No approved orders',
            cancelled: 'No cancelled orders',
            default: 'No orders found',
        },
    },
    liveOrdersContainer: {
        tooltip: {
            hideStops: 'Hide stops',
            showStops: 'Show stops',
        },
    },
    bulkImport: {
        messages: {
            duplicateInvoice: `There are duplicate invoices for the selected distribution zone and client. Please check your file and try again.`,
            internealError: 'Bulk import failed. Please contact Shyftbase team.',
            success: 'Successfully imported.',
        },
        templateSetting: {
            instruction: 'Copy your sheet license key from the CSV Box account that is created for you.',
            notFound: 'No templates found.',
        },
    },
    rateTable: {
        notDefined: 'Please check the rate table. There are no available services or the rate table is not defined',
        messages: {
            otherErr: 'Something went wrong. Please contact Shyftbase.',
            duplicateRateTable: 'Duplicate rate table: You have rate table for the selected region, client, type, and mode ({{error}})',
        },
        contractorRate: {
            noContractor: 'Please select at least one contractor',
        },
        connectingLoaderMessage: 'Connecting rates...',
        noDriverShiftRate: 'No driver shift rate found',
        connectingDriverShiftRate: 'Connecting driver shift rate...',
        noRatesFound: 'No rates found',
        bulkEdit: {
            submit: 'Submit',
            close: 'Close',
            warning: 'This will overwrite rate table values',
            title: 'Bulk Edit Rate Tables',
            success: 'Rate table settings have been updated',
            noClients: 'No clients are selected',
            noDistributionZones: 'No distribution zones are selected',
            confirmNullTitle: 'Confirm Bulk Edit',
            confirmNullText: 'No values are selected. This will remove all previous values.',
            differentTypeWarning: 'Please select rates with the same type.',
            noData: 'No values are selected.',
        },
    },
    liveOrder: {
        orderType: {
            Delivery: 'Delivery',
            Pickup: 'Pickup',
            'Service Call': 'Service Call',
            'Store-Stop': 'Store-Stop',
        },
        cancellationReason: {
            RESCHEDULE: 'RESCHEDULE',
            'NO STOCK': 'NO STOCK',
            'CANCELLED BY CUSTOMER': 'CANCELLED BY CUSTOMER',
            'ADDRESS NOT FOUND': 'ADDRESS NOT FOUND',
            'ADULT NOT PRESENT': 'ADULT NOT PRESENT',
            'PREVIOUSLY DONE': 'PREVIOUSLY DONE',
            'BOOKING ERROR': 'BOOKING ERROR',
            'CANCELLED BY STORE': 'CANCELLED BY STORE',
            'CANCELLED TO RESCHEDULE': 'CANCELLED TO RESCHEDULE',
            'CREATED - NO STOCK': 'CREATED - NO STOCK',
            'DELIVERY TEAM ILLNESS / INJURY': 'DELIVERY TEAM ILLNESS / INJURY',
            'DUPLICATE ORDER': 'DUPLICATE ORDER',
            'FLY BY - NO PRODUCT AVAILABLE': 'FLY BY - NO PRODUCT AVAILABLE',
            'INCORRECT ADDRESS': 'INCORRECT ADDRESS',
            'INCORRECT ADDRESS - NOT LOADED ON TRUCK': 'INCORRECT ADDRESS - NOT LOADED ON TRUCK',
            'INSUFFICIENT MANPOWER': 'INSUFFICIENT MANPOWER',
            'INSUFFICIENT MANPOWER - NOT LOADED ON TRUCK': 'INSUFFICIENT MANPOWER - NOT LOADED ON TRUCK',
            'NAH - OUTSIDE WINDOW': 'NAH - OUTSIDE WINDOW',
            'NO STOCK - MID MILE DELAY': 'NO STOCK - MID MILE DELAY',
            'NO STOCK LOCATED AT HUB': 'NO STOCK LOCATED AT HUB',
            'OVERSIZED PRODUCTS(S)': 'OVERSIZED PRODUCTS(S)',
            'PRODUCT NOT LOADED': 'PRODUCT NOT LOADED',
            'PROPERTY DAMAGE': 'PROPERTY DAMAGE',
            'PROPERTY NOT ACCESSIBLE': 'PROPERTY NOT ACCESSIBLE',
            'REFUSED - CONCEALED DAMAGE': 'REFUSED - CONCEALED DAMAGE',
            'REFUSED - DRIVER DAMAGE': 'REFUSED - DRIVER DAMAGE',
            'REFUSED - INCORRECT PRODUCT ORDERED': 'REFUSED - INCORRECT PRODUCT ORDERED',
            'REFUSED - INCORRECT PRODUCT SHIPPED': 'REFUSED - INCORRECT PRODUCT SHIPPED',
            'REFUSED - PRODUCT DEFECTIVE': 'REFUSED - PRODUCT DEFECTIVE',
            'RESCHEDULED BY CUSTOMER - NOT LOADED ON TRUCK': 'RESCHEDULED BY CUSTOMER - NOT LOADED ON TRUCK',
            'RESCHEDULED BY CUSTOMER': 'RESCHEDULED BY CUSTOMER',
            'VEHICLE ISSUES': 'VEHICLE ISSUES',
            'WEATHER - NOT LOADED ON TRUCK': 'WEATHER - NOT LOADED ON TRUCK',
            'WEATHER ISSUES': 'WEATHER ISSUES',
        },
        orderStatus: {
            'Need Attention': 'Need Attention',
            Pending: 'Pending (Customer Portal)',
            Cancelled: 'Cancelled',
            Approved: 'Approved',
        },
        message: 'Message',
        edit: 'Edit',
        viewDetail: 'View Detail',
        viewLess: 'View Less',
        tooltip: {
            message: 'Open chat to communicate about this order',
            edit: 'Edit order details',
            viewDetails: 'Toggle detailed information',
        },
    },
    orderEntry: {
        viewPendingOrder: 'View Pending Orders',
        title: {
            create: 'Create New Order',
            update: 'Update Order',
        },
        subtitle: {
            zone: 'Zone : ',
            pickupDate: 'Pickup Date',
            deliveryDate: 'Delivery Date',
            scheduledDate: 'Scheduled Date',
            services: 'Services',
            products: 'Products',
        },
        placeholder: {
            placeOrderTakingTimeMessage: 'This may take a few seconds',
            select: 'Please Select Order Type',
            postalCode: 'Customer Postal Code (Example: L0C1E0)',
            selectReturn: 'Select Return Type',
            selectedDate: 'Selected Date: ',
            additionalInfo: 'Additional Info',
        },
        caution: {
            first: 'If scheduling a',
            second: ' haulaway ',
            third: ' , please select',
            fourth: ' service only',
            fifth: 'option.',
        },
        button: {
            check: 'Check Availabilities',
            submit: 'Submit',
        },
        messages: {
            submitError:
                'Sorry, booking for this postal code is not possible at this time! Please check the postal code you entered. If you believe this is a mistake, please make a request for this postal code to be added to the supported zones by sending an email to hcustome@bestbuycanada.ca',
            selectActiveDate: 'Please select active date',
            saveProduct: 'Please make sure products are saved!',
            saveService: 'Please make sure service is saved!',
            selectDate: 'Please make sure date is selected!',
            validInvoice: 'Please make sure invoice is valid!',
            validInvoiceFormat: 'Please make sure invoice format is "XXX-XXXXXX" in numbers',
            validPhone: 'Please make sure phone is valid!',
            validFirstName: 'Please make sure first name is valid!',
            validLastName: 'Please make sure last name is valid!',
            validStreet: 'Please make sure street is valid!',
            validCity: 'Please make sure city is valid!',
            validUnit: 'Please make sure unit number is valid!',
            orderAdded: 'Order was added to the pending list of orders!',
            orderUpdated: 'Order was successfully updated!',
            somethingWentWrong: 'Sorry, something went wrong. Please close this message and submit again.',
            lanudryAndFridgeDoorMsg:
                'Please confirm the unit being serviced is new or purchased and delivered by Metro To Home within 30 days.',
            isAccessoriesNew: "Are all the accessories new or used? Click 'Yes' if 'New', 'No' if 'Used'.",
            haulawayMsg:
                'Please note you have selected a haulaway service which will send the unit for recycling. Please ensure the customer uninstalls the unit and prepares it for pickup before our team arrives.',
            largeHawlawayMsg:
                'please note our haulaway service is a one for one service. Please review the quantity requested and resubmit.',
            generateLargeQtyMessage:
                'This is not a regular size home delivery, as such please make sure to follow the large order process on ETK.',
            generateFourManMessage: '4-man delivery: Please make sure to provide details, SKU and QTY in the comments.',
            generateReturnMessage:
                'Return to DC - Please make sure to provide details (REASON FOR RETURN) in the comments.',
            serviceConditionRequirement: 'service condition requirement is not met.',
            generateInvoiceAuthMessage: 'Sorry, only Admin has the permission to create 900 orders.',
            oversizeFridge: 'Please provide the details and the SKU / QTY in the comments.',
            over90Days:
                'You have selected a date that is over 90 days threshold. Please make sure the selected date is correct.',
            usedAccessories:
                'Installation accessories must be new and unopen in order for our home delivery provided to complete the installation.',
            yes: 'Yes',
            no: 'No',
            duplicateInovice:
                'The invoice number you entered already exists for the selected region and clients. Please enter a unique invoice number.',
        },
        options: {
            flyby: 'Fly By',
            serviceCall: 'Service Only',
            pickup: 'Pickup',
        },
    },
    serviceList: {
        service: 'Service',
        qty: 'QTY',
        remove: 'Remove',
    },
    saveServiceForm: {
        selectService: 'Select Service',
        saveService: 'Save Service',
        qty: 'QUANTITY',
        options: {
            fourMan: '4-man delivery-Specify details in comments',
            LevelUnit: 'Level Unit',
            MoveUnit: 'Move Unit in Place',
            Pedestal: 'Pedestal set up',
            StackingLaundry: 'Stacking Laundry',
            WasherConnection: 'Washer Connection',
            DryerConnection: 'Dryer Connection',
            WasherandDryerConnection: 'Washer and Dryer Connection',
            FridgeDoorSwing: 'Fridge Door Swing',
            OversizeFridge: 'Oversize Fridge (+26/350LB)',
            Haulaway: 'Haulaway',
            Doorstep: 'Doorstep',
        },
    },
    productList: {
        product: 'Product',
        qty: 'QTY',
        sku: 'SKU',
        model: 'MODEL',
        remove: 'remove',
    },
    saveProductForm: {
        name: 'PRODUCT NAME',
        qty: 'QUANTITY',
        sku: 'SKU',
        model: 'MODEL',
        save: 'Save Product',
    },
    history: {
        loading: 'Loading...',
        filter: 'filter',
        group: 'group orders',
        sort: 'sort orders',
    },
    viewSettings: {
        deleteConfirmation: 'Are you sure you want to delete this view?',
        deleteWarning: 'This will delete the view "{{name}}" and all its settings.',
        delete: 'Delete',
        cancel: 'Cancel',
        noViews: 'No views found',
        emptyState: {
            title: 'No views available',
            description: 'Save your favourite filters and date ranges as views to access later. Share views with external parties for quick view-only access.',
            createFirstView: 'Create your first view to get started'
        },
        shareLink: 'Share link',
        type: 'Type',
        regions: 'Regions',
        clients: 'Clients',
        dateRange: 'Date Range',
        copyLink: 'Copy link',
        sharingSettings: 'Sharing Settings',
        warning: {
            accessClientZones: `You don't have access to the clients or distribution zones of this view.`,
            selectView: 'You must create a new view or load the saved view from the Views menu',
            bindClientZones: `This view has no linked client and distribution zone. Please create a new view with linking`,
        },
        createNewView: 'Create new view',
        name: 'Name',
        enterName: 'Enter view name...',
        configurationSaved: 'What this view will save',
        visibleColumns: 'Visible columns',
        columnOrder: 'Column order',
        grouping: 'Grouping',
        appliedFilters: 'Applied filters',
        create: 'Create view',
        personal: 'Personal',
        shared: 'Shared',
        bindClientDistributionzones: 'Save the current clients, distribution zones and date range',
        bindClientZonesHelp: `The clients and zones are reloaded with the view. The date range is saved for the external link only — in the portal the view follows the date range you have selected. Without this setting the view keeps whatever clients and zones you have at the time and applies only the date option above.`,
        columnLayoutSaved: 'The current column layout — which columns are visible and the order they appear in — is always saved.',
        shareExternally: 'Create a shareable external link',
        shareExternallyHelp: 'Anyone with the link can open this view without signing in. You can add a password, allow copying, or turn the link off again at any time from View settings.',
        shareExternallyRequires: 'Turn on the setting above first. A shared link has no signed-in user to take clients, zones and a date range from, so it can only work on a view that saved its own.',
        linkAvailableAfterCreate: 'The link is generated when the view is created. You can copy it afterwards from View settings.',
        dateRangeBinding: 'Selected date range will be saved with this view',
        allowsSameOrdersLater: 'allows you to pull the same orders when loading this view later',
        distributionZonesAndClients: 'distribution zones and clients will be linked.',
        copyToClipboard: 'Link copied to clipboard. You can now share it',
        hasClientZones: 'This view includes linked clients and distribution zones',
        passwordProtected: 'This view is password protected',
        pinAsDefault: 'Pin as default view',
        unpinDefault: 'Unpin default view',
        defaultView: 'Default view for this page',
        pinnedDefault: 'View pinned as your default',
        unpinnedDefault: 'Default view removed',
        error: {
            fetchFailed: 'Failed to fetch views. Please try again.',
            copyFailed: 'Failed to copy link. Please try again.',
            updateFailed: 'Failed to update view. Please try again.',
            deleteFailed: 'Failed to delete view. Please try again.',
        },
        sharedView: {
            setPassword: {
                title: 'A password is required to view this content',
                subTitle: "This password is not the same as your Shyftbase account's password",
            },
            allowCopy: 'Allow data copying',
            showAllFields: 'Show all fields in expanded records',
            restrictAccess: 'Restrict by password',
            disable: 'Disable link',
            enable: 'Enable link',
            notAvailable: {
                title: 'The private share link you tried to reach is not available.',
                subTitle:
                    'The owner of this view may have unshared or deleted it. Please contact them if you need access.',
            },
            verifyPassword: 'Enter password to view content',
            wrongPassword: 'Incorrect password. Please try again.',
        },
        new: 'New',
        searchViews: 'Search views...',
        personalViews: 'Personal Views',
        noPersonalViews: 'No personal views found.',
        sharedViews: 'Shared Views',
        noSharedViews: 'No shared views found.',
        startWindow: 'Start Window',
        manageSharing: 'View settings',
        sharedViaLink: 'Shared via external link',
        pullScope: 'Data pulled',
        tableLayout: 'Table layout',
        groupedBy: 'Grouped by',
        filters: 'Filters',
        notGrouped: 'Not grouped',
        noFilters: 'No filters',
        dateBasis: 'Date',
        dateRangeExternalOnly: 'Used by the external link only. In the portal, this view always uses the date range you have selected.',
        allZones: 'All distribution zones',
        allClients: 'All clients',
        none: 'None',
        dateOptions: {
            today: 'Today',
            tomorrow: 'Tomorrow',
            yesterday: 'Yesterday',
            none: 'No date saved',
        },
        howToUpdate: {
            title: 'How to update this view',
            layout: 'Table layout — arrange the columns, grouping and filters in the grid the way you want them, then click the save icon on this view in the panel.',
            scope: `Clients, zones and date range — only views saved with the current clients and distribution zones keep these. Change them in the pull form, run the pull, then click save. Note the saved date range is used by the external link only; in the portal this view always follows the date range you have selected.`,
            fixed: `A view's name, its mode, and whether it is tied to specific clients and distribution zones are set when it is created. Make a new view to change any of them. (This does not affect the share link above, which you can turn on and off at any time.)`,
        },
    },
    calendarSettings: {
        title: {
            title: 'Calendar Setting',
            selectDistributionZoneAndClient: 'Select distribution zone and client to start',
        },
        placeholder: {
            selectZone: 'Select Zone',
            selectMonth: 'select month',
            selectBDays: 'select business days',
        },
        setMaxBooking: 'Set max booking date',
        subSetMaxBooking: '(How far ahead should customers be able to book)',
        monthFromToday: 'month(s) from today',
        submit: 'submit',
        setEarliestBooking: 'Set earliest available days including today',
        subSetMinBooking:
            '(eg: 2 means the earliest available date will be after 2 business days from the date the delivery is being places)',
        includingToday: 'business days including today',
        messages: {
            changePostalCode:
                'Customized days above override the postal code schedules. If you need to change postal code schedules please email us at admin@shyftbase.com.',
            followingDate: 'the following date ',
            default: 'Change back to default service schedule based on postal codes.',
        },
        colorCodes: 'Color codes: ',
        disabledDays: 'disabled days',
        enabledDays: 'enabled days',
        select: 'select',
        enable: 'enable',
        disable: 'disable',
        updateCalener: 'Update Callendar Setting',
        warning: {
            overwrite: 'There are predefined setting for follwing clients.<br/>This work will overwrite the setting.',
        },
    },
    distributionZoneMapping: {
        subtitle: 'Distribution Zone Mapping - Select region to start',
        'Select Region': 'Select Region',
        'Select Distribution Zones': 'Type and Search Distribution Zone',
        'Currently Mapped Distribution Zones': 'Currently Mapped Distribution Zones',
        Update: 'Update',
        Reset: 'Reset',
        None: 'None',
        Updated: 'Updated {0} Distribution Zones',
        Added: 'Added {0} to Regions List',
    },
    clientSetting: {
        error: {
            IncompletForm:
                'Form is incomplete! Business Unit, Sub Business Unit, Regions, and Data Source cannot be empty',
        },
    },
    accessTable: {
        accessLevels: 'Access Levels',
        toggle: 'Toggle Access Hierarchy',
        save: 'Save',
        searchByName: 'Search by name...',
        noUser: 'No users found',
        emailAdmin: '',
        name: 'Name',
        access: 'Access',
        'Create a new one': 'Create a new one',
        'User access updated': 'User access updated',
        Region: 'Region',
        Actions: 'Actions',
        Client: 'Client',
        Vendor: 'Client',
    },
    updateOrderInfo: {
        title: 'Update Order',
        startWindow: 'Start Window',
        selectedDate: 'Selected Date: ',
        services: 'Services',
        products: 'Products',
        additionalInfo: 'Additional Info',
        submit: 'Submit',
        ok: 'OK',
        messages: {
            somethingWentWrong: 'Something went wrong! Please try again.',
            pending: 'Order was update to the pending list of orders!',
        },
    },
    orderDisplay: {
        tooltip: {
            confirmUnconfirmBillingState: 'Confirm / unconfirm the billing state of the order',
            confirmUnconfirmSettlementState: 'Confirm / unconfirm the settlement state of the order',
            confirmUnconfirmBothState: 'Toggle the billing & settlement state of the order',
            lockBillingState:
                'Lock the billing state of the order. This will prevent the order from being updated again unless the order is unconfirmed',
            lockSettlementState:
                'Lock the settlement state of the order. This will prevent the order from being updated again unless the order is unconfirmed',
            unlockVehicle: 'Unlock the vehicle. Locked vehicles cannot be updated',
            operationStatus: 'Operation Statuses',
            serviceList: '{{mode}} Service List',
        },
    },
    orderDetailModal: {
        requestInfo: 'Request Info (Move To Need Attention)',
        typeMessage: 'Please type your messeage',
        approve: 'Approve Order',
        areYouSure: 'Are you sure?',
        yes: 'Yes',
        no: 'No',
        cancelOrder: 'Cancel Order',
        update: 'Update',
        selectAction: 'Select Action/View Details',
    },
    orderDetail: {
        invoice: 'Invoice / Order Number',
        customer: 'Customer',
        email: 'Email',
        phone1: 'Phone 1',
        phone2: 'Phone 2',
        products: 'Products',
        services: 'Services',
        startWindow: 'Start Window',
        address: 'Address',
        pickupAddress: 'Pickup Address',
        dispatchComments: 'Dispatch Comments',
    },
    cancellationHandler: {
        selectReasonTitle: 'Select Reason',
        options: {
            RESCHEDULE: 'RESCHEDULE',
            'NO STOCK': 'NO STOCK',
            'CANCELLED BY CUSTOMER': 'CANCELLED BY CUSTOMER',
            'ADDRESS NOT FOUND': 'ADDRESS NOT FOUND',
            'ADULT NOT PRESENT': 'ADULT NOT PRESENT',
            'PREVIOUSLY DONE': 'PREVIOUSLY DONE',
            'BOOKING ERROR': 'BOOKING ERROR',
            'CANCELLED BY STORE': 'CANCELLED BY STORE',
            'CANCELLED TO RESCHEDULE': 'CANCELLED TO RESCHEDULE',
            'CREATED - NO STOCK': 'CREATED - NO STOCK',
            'DELIVERY TEAM ILLNESS / INJURY': 'DELIVERY TEAM ILLNESS / INJURY',
            'DUPLICATE ORDER': 'DUPLICATE ORDER',
            'FLY BY - NO PRODUCT AVAILABLE': 'FLY BY - NO PRODUCT AVAILABLE',
            'INCORRECT ADDRESS': 'INCORRECT ADDRESS',
            'INCORRECT ADDRESS - NOT LOADED ON TRUCK': 'INCORRECT ADDRESS - NOT LOADED ON TRUCK',
            'INSUFFICIENT MANPOWER': 'INSUFFICIENT MANPOWER',
            'INSUFFICIENT MANPOWER - NOT LOADED ON TRUCK': 'INSUFFICIENT MANPOWER - NOT LOADED ON TRUCK',
            'NAH - OUTSIDE WINDOW': 'NAH - OUTSIDE WINDOW',
            'NO STOCK - MID MILE DELAY': 'NO STOCK - MID MILE DELAY',
            'NO STOCK LOCATED AT HUB': 'NO STOCK LOCATED AT HUB',
            'OVERSIZED PRODUCTS(S)': 'OVERSIZED PRODUCTS(S)',
            'PRODUCT NOT LOADED': 'PRODUCT NOT LOADED',
            'PROPERTY DAMAGE': 'PROPERTY DAMAGE',
            'PROPERTY NOT ACCESSIBLE': 'PROPERTY NOT ACCESSIBLE',
            'REFUSED - CONCEALED DAMAGE': 'REFUSED - CONCEALED DAMAGE',
            'REFUSED - DRIVER DAMAGE': 'REFUSED - DRIVER DAMAGE',
            'REFUSED - INCORRECT PRODUCT ORDERED': 'REFUSED - INCORRECT PRODUCT ORDERED',
            'REFUSED - INCORRECT PRODUCT SHIPPED': 'REFUSED - INCORRECT PRODUCT SHIPPED',
            'REFUSED - PRODUCT DEFECTIVE': 'REFUSED - PRODUCT DEFECTIVE',
            'RESCHEDULED BY CUSTOMER - NOT LOADED ON TRUCK': 'RESCHEDULED BY CUSTOMER - NOT LOADED ON TRUCK',
            'RESCHEDULED BY CUSTOMER': 'RESCHEDULED BY CUSTOMER',
            'VEHICLE ISSUES': 'VEHICLE ISSUES',
            'WEATHER - NOT LOADED ON TRUCK': 'WEATHER - NOT LOADED ON TRUCK',
            'WEATHER ISSUES': 'WEATHER ISSUES',
        },
    },
    orderInfo: {
        placeholder: {
            invoice: 'Invoice/value',
            firstName: 'First Name',
            lastName: 'Last Name',
            phone1: 'Phone 1',
            phone2: 'Phone 2',
            email: 'Email',
            appt: 'Appartment',
            unit: 'Unit #',
            street: 'Street / Drive',
            city: 'City / Town',
            postalCode: 'Postal Code',
        },
    },
    bbUserAccessCell: {
        selectOrderType: 'Please Select Order Type',
    },
    chatHistory: {
        title: 'Chat History',
        reply: 'Reply',
        submit: 'Send',
    },
    quickActions: {
        internalError: 'Something went wrong. Please contact Shyftbase.',
        selectAction: 'Select an action to start',
        moveToUnassigned: {
            title: 'Move to Unscheduled',
            warningDuplicateOrders: 'There are duplicate unscheduled orders. Those orders will be ignored to generate a new unscheduled order.',
            unassignAllProducts: 'Unassign all products',  
            noProductToUnassign: 'It is required to select at least one product to unassign.',
            validationError: 'You cannot create a new unscheduled order with the same invoice',
        },
        rescheduleOrder: {
            title: 'Reschedule Order',
            originalOrderStatus: 'Original Order Status',
            originalProductStatus: 'Original Product Status',
            rescheduleAllProducts: 'Reschedule all products',
            warningMultipleOrders: 'You cannot reschedule multiple orders',
            noProductToReschedule: 'It is required to select at least one product to reschedule.',
            noDate: 'It is required to select a date to reschedule.',
            noStatus: 'It is required to select a order status for the original order.',
            loadCalendar: 'Load Calendar',
            selectStatus: 'Select Status',
        },
        success: 'Order(s) updated successfully',
    },
    report: {
        dateRangeMsg: '* If date range is longer than 2 weeks, pleaes use `Download survey report - archive`',
        liveArchiveDataSourceMsg:
            '* To ensure you have the most recent results from the day before, please download the survey from the live data source.',
        download: 'Download survey reports',
        donwloadFromLiveData: 'Download survey report - live data',
        downloadData: 'Download data',
        viewReport: 'View Report',
        selectDateRange: 'Select Date Range',
        success: 'Report was successfully downloaded.',
        noDate: 'Date was not selected',
        noRecords: 'No records are found. Please set different date range and try again',
        noAuth: 'User not authorized. Only authorized staff can donwload report.',
        liveDataMsg:
            '* Live Data: Scope is limited to the live data only. Please use the archive extract of you need to download historical data.',
        'Download survey report - comments': 'Download survey report - comments',
    },
    fields: {
        Invoice: 'Invoice',
        OrderType: 'Order Type',
        StartWindow: 'Start Window',
        EndWindow: 'End Window',
        Products: 'Products',
        actions: 'Actions',
        OrderStatus: 'Order Status', // order status
        CustomerName: 'Customer Name',
        Phone1: 'Phone 1',
        Phone2: 'Phone 2',
        Email: 'Email',
        PickupAddress: 'Pickup Address',
        DropoffAddress: 'Dropoff Address',
        DriverNotes: 'Driver Notes',
        DriverServices: 'Driver Services',
        PlannedServices: 'Planned Services',
        StartedAt: 'Started At',
        ArrivedAt: 'Arrived At',
        CompletedAt: 'Completed At',
        BestBuyRobocallStatus: 'Robocall Status',
        BestBuySurveyQ1: 'Survey Q1',
        BestBuySurveyQ2: 'Survey Q2',
        BestBuySurveyQ3: 'Survey Q3',
        BestBuySurveyQ4: 'Survey Q4',
        BestBuySurveyQ5: 'Survey Q5',
        BestBuySurveyQ6: 'Survey Q6',
        BbGiftCustomerEmail: 'Gift Card Email',
        BbGiftAmount: 'Gift Card Amount',
        CancellationReason: 'Cancellation Reason',
        CalledCallCenter: 'Called CallCenter',
        BbCustomerEmailForSurvey: 'Survey Email',
        BbCustomerSurveyComment1: 'Survey Comment 1',
        BbCustomerSurveyComment2: 'Survey Comment 2',
        BestBuyRobocallTimestamp: 'Robocall Timestamp',
        Services: 'Services',
        Region: 'Region',
        DeliveryAssignee: 'Delivery Assignee',
        Vehicle: 'Vehicle',
        DispatchComments: 'Dispatch Comments',
        ServiceTime: 'Service Time',
        // TextMsgLogs: "Text Message Logs",
        DispatchLog: 'Dispatch Log',
        Store: 'Store',
        Pod: 'POD',
        CustomerSignature: 'Customer Signature',
        DistributionZone: 'Distribution Zone',
        Client: 'Client',
    },
    vuetableDetailModal: {
        orderInfo: 'ORDER INFO',
        imageAttachment: 'IMAGE ATTACHMENT',
        productDetail: 'PRODUCT DETAIL',
        product: {
            Product: 'Product',
            QTY: 'QTY',
            SKU: 'SKU',
            WEIGHT: 'WEIGHT',
            MANUFACTURER: 'MANUFACTURER',
            VOLUME: 'VOLUME',
            SERIAL: 'SERIAL',
            MODEL: 'MODEL',
            BARCODE: 'BARCODE',
            COMMENT: 'COMMENT',
        },
        driverNotes: 'Driver Notes',
        textMsgLogs: 'Text Message Log',
    },
    admin: {
        tooltip: {
            taxRates: 'Manage TAX Rates',
            integrations: 'Integrations',
            role: 'Create and manage roles, fields settings, access points and privileges',
            client: 'Set up your client profiles',
            contractor: 'Set up your contractor profiles',
            user: 'Create and manage users or drivers (agents)',
            orderStatus: 'Manage all the statuses in the system',
            calendar: 'Manage calendars to allow or restrict booking dates or client rescheduling',
            notification: 'Manage notifications and alerts',
            automation: 'Manage automation settings',
            fields: 'Manage order fields settings',
            rateTable: 'Manage custom rate cards used by the automated billing module',
            zones: 'Manage zones based on kilometer bands, postal codes, or other criteria',
            services: 'Global services table. You will be able to manage the services per rate cards later on',
            conditions: 'Manage billing and settlement conditions',
            tiersEscrow: 'Set up tiers and escrow',
            fuelSurcharge: 'Manage fuel surcharge rates',
            weeklyFuelSurcharge: 'Upload and manage your weekly fuel surcharge rates',
            ikeaPostalCodes: 'Manage postal codes',
            globalUnits: 'Manage measurement units',
        },
        SetupYourBusiness: 'Set Up Your Business',
        SetupBillingModule: 'Set Up Billing Module',
        Automations: 'Automations',
        Integrations: 'Integrations',
        'Admin Settings': 'Settings',
        'Your Business, Your Way': 'Your Business, Your Way',
        'Access Table': 'User Access Management',
        'Admin Action': 'Admin Action',
        'Calendar Settings': 'Calendar Settings',
        'Driver Settings': 'Driver',
        'Distribution Zone Mapping': 'Distribution Zone Mapping',
        'Client Settings': 'Customer',
        'Fleet Settings': 'Fleet',
        'Contactless Delivery Settings': 'Contactless Delivery',
        'Metro Driver Settings': 'Metro Driver',
        'Role Settings': 'Roles',
        'User Management': 'User Management',
        'Business Logic Center': 'Business Logic Center',
        'Client Profile Settings': 'Client Profiles',
        'Contractor Profile Settings': 'Contractor Profiles ',
        'General Settings': 'General',
        'Notification Settings': 'Notifications',
        'Postal Codes': 'Postal Codes',
        displayName: 'Manage API Keys',
        fields: {
            Yes: 'Yes',
            No: 'No',
            Cancel: 'Cancel',
            'Add New User': '+ New User',
            'Create Vendor Profile': 'Create Client Profile',
            'Edit Vendor Profile': 'Update Client Profile',
            'Delete Vendor Profile': 'Delete Client Profile',
            'Create Contractor Profile': 'Create Contractor Profile',
            'Edit Contractor Profile': 'Edit Contractor Profile',
            'Delete Contractor Profile': 'Delete Contractor Profile',
            'Business Unit': 'Business Unit',
            'Sub Business Unit': 'Sub Business Unit',
            'Company Name': 'Company Name',
            Active: 'Active',
            Escrow: 'Escrow',
            address: 'Address',
            allowAllRegion: 'Allow All Region',
            billingCode: 'Billing Code',
            businessUnit: 'Business Unit',
            customerCanReschedule: 'Customer Can Reschedule',
            customerRescheduleAvailableDayThreshold: 'Customer Reschedule Available Day Threshold',
            dataSource: 'DataSource',
            id: 'id',
            inventory: 'Inventory',
            invoiceTemplate: 'Invoice Template',
            logoDownloadURL: 'Logo URL',
            logoFile: 'Logo File',
            regions: 'Regions',
            reverseLogistics: 'Reverse Logistics',
            settlementTemplate: 'Settlement Template',
            shouldGeocode: 'Should Geocode',
            shouldSendSurvey: 'Should Send Survey',
            enableQuote: 'Enable Quote',
            subBusinessUnit: 'Sub Business Unit',
            trucks: 'Trucks',
            table: 'Table',
            tier: 'Tier',
            minPayable: 'Min Payable',
            hourlyRate: 'Hourly Rate',
        },
        automations: {
            actionButtonTitle: '+ Automations',
        },
        userHistory: {
            limitInfo: 'History is limited to the last 300 items. An expansion will be added later on.',
        },
        fieldsSettings: {
            title: 'Add & Define New Fields: Craft Your Custom Logic for Enhanced Operations Across Your Business',
        },
        deleteConfirmModal: {
            title: 'Confirm deletion',
            warningTitle: `Warning: Deleting this {{category}} rate will result in the following.`,
            warningDescription1: `All rate tables referencing this {{category}} will lose this association.`,
            warningDescription2: `This {{category}} will no longer be factored into calculations for existing orders.`,
            confirmDelete: `Are you certain you wish to proceed with the removal of this {{category}} rate?`,
        },
        taxRates: {
            createTaxRate: 'Create Tax Rate',
            editTaxRate: 'Edit Tax Rate for {{province}}',
            province: 'Province',
            emptyProvince: 'Province is required',
            ratePercentage: '{{type}} Rate (%)',
            successCreate: 'Successfully created',
            successUpdate: 'Successfully updated',
            unknownError: 'There was an unknown error',
            enterProvince: 'Enter the name of the province',
            table: {
                header: {
                    action: 'Actions',
                    province: 'Province',
                }
            },
            taxes: {
                createEdit: {
                    title: {
                        create: 'Create Tax Rate',
                        edit: 'Edit Tax Rate for {{province}}'
                    },
                    province: {
                        label: 'Province',
                        placeholder: 'Enter the name of the province'
                    },
                    rates: {
                        label: '{{type}} Rate (%)',
                        gst: 'GST',
                        pst: 'PST',
                        hst: 'HST',
                        qst: 'QST'
                    },
                    submit: 'Save',
                    cancel: 'Cancel',
                    validation: {
                        provinceRequired: 'Province is required'
                    },
                    success: {
                        create: 'Successfully created',
                        update: 'Successfully updated'
                    },
                    error: 'There was an unknown error'
                }
            }
        },
        billingAdmin: {
            tableSettings: {
                bulkUpdate: {
                    selectRows: 'You need to select more than one row to perform a bulk update.',
                    title: 'Bulk Update',
                    overwriteConfirmation: {
                        title: 'Warning!',
                        message: 'You are about to overwrite existing values! This action cannot be undone. Please confirm to proceed.'
                    },
                    overwriteLabels: {
                        values: 'Overwrite existing values',
                        rules: 'Overwrite existing rules',
                        services: 'Overwrite existing services'
                    }
                },
               
            },
            conditions: {                
                title: 'Conditions',
                newCondition: 'New Condition',
                editCondition: 'Edit Condition',
                viewCondition: 'View Condition',
                name: 'Name',
                label: 'Label',
                description: 'Description', 
                type: 'Type',
                rules: 'Rules',
                applicationStructure: 'Application Structure',
                defaultService: 'Default Service',
                fee: 'Fee',
                serviceType: 'Service Type',
                billable: 'Billable',
                settlement: 'Settlement',
                logicalOperator: 'Logical Operator',
                field: 'Field',
                operator: 'Operator',
                amount: 'Amount',
                action: 'Action',
                service: 'Service',
                adminPurpose: 'For administrative purposes',
                invoiceLabel: 'Label will be displayed to customers in the Invoice/Settlement',
                delete: 'Delete',
                save: 'Save',
                cancel: 'Cancel',
                table: {
                    header: {
                        action: 'Actions',
                        name: 'Name',
                        description: 'Description',
                        type: 'Type',
                    }
                },
                ruleFields: {
                    condition: 'Condition',
                    majorProductWeight: 'Major Product Weight',
                    majorProductVolume: 'Major Product Volume',
                    majorProduct: 'Major Product',
                    totalWeight: 'Total Weight',
                    totalVolume: 'Total Volume',
                    totalQuantity: 'Total QTY',
                    orderType: 'Order Type',
                    settlementService: 'Settlement Service',
                    billableService: 'Billable Service',
                    substatus: 'Substatus'
                },
                fees: {
                    flat: 'Flat',
                    majorProductWeight: 'per Major Product Weight',
                    majorProductVolume: 'per Major Product Volume',
                    majorProduct: 'per Major Product',
                    totalWeight: 'Total Weight',
                    totalVolume: 'Total Volume',
                    totalQuantity: 'Total QTY',
                    perWeightExcess: 'Per Weight in excess of',
                    perVolumeExcess: 'Per Volume in excess of',
                    perQuantityExcess: 'Per Quantity in excess of',
                    percentBaseRate: '% Base Rate',
                    percentTotal: '% Total',
                    perDistance: 'Per Distance',
                    perDriverWaitingMinutes: 'Per Driver Waiting Minutes',
                    charge: 'Charge',
                    feePlaceholder: 'Fee',
                    applicationMethod: 'Application Method',
                    excessAmount: 'Excess Amount',
                    excessPlaceholder: 'Excess'
                }
            },
            services: {
                title: 'Services',
                newService: 'Create Service',
                editService: 'Edit Service',
                serviceName: 'Service Name',
                mode: 'Mode',
                bbCode: 'BB Code',
                startDate: 'Start Date',
                expiryDate: 'Expiry Date',
                enterServiceName: 'Enter service name',
                enterBBCode: 'Enter BB code',
                nameRequired: 'Name cannot be empty'
            },
            status: {
                title: 'Status',
                newStatus: 'Create Status',
                editStatus: 'Edit Status', 
                name: 'Name',
                billable: 'Billable',
                settlements: 'Settlements',
                lifeCycle: 'Life Cycle',
                orderStatus: 'Order Status',
                cancellationReason: 'Cancellation Reason',
                productStatus: 'Product Status',
                operationStatus: 'Operation Status',
                lockStatus: 'Lock Status',
                skipRouting: 'Skip Routing',
                skipStem: 'Skip Stem',
                rate: 'Rate',
                selectOption: 'Select option',
                enterName: 'Please enter a name'
            },
            fsc: {
                title: 'FSC Rates',
                newRate: 'Create FSC Rate',
                editRate: 'Edit FSC Rate',
                from: 'From',
                to: 'To',
                billingRate: 'Billing Rate',
                settlementRate: 'Settlement Rate',
                clients: 'Clients',
                validation: {
                    toAndBillingRequired: 'To and Billing Rate cannot be empty(or 0)',
                    fromGreaterThanTo: 'From cannot be greater than To',
                    clientExists: 'The FSC rate for the one of selected client is already exists'
                }
            },
            serviceName: 'Service Name',
            amount: 'Amount',
            action: 'Action',
            add: 'Add',
            delete: 'Delete',
            defaultServices: {
                placeholder: {
                    amount: 'Amount'
                }
            },
            rule: {
                logicalOperator: 'Logical Operator',
                field: 'Field',
                service: 'Service',
                operator: 'Operator',
                amount: 'Amount',
                action: 'Action',
                delete: 'Delete',
                selectOption: 'Select option',
                orderType: 'Order Type',
                serviceLevel: 'Service Level',
                subStatus: 'Substatus'
            },
            operators: {
                "=": '=',
                "<": '<',
                '<=': '<=', 
                '>': '>',
                '>=': '>=',
                'Isanyof': 'Is any of',
                'Isnoneof': 'Is none of'
            },
            createEdit: {
                title: {
                    create: 'Create Status',
                    edit: 'Edit Status'
                },
                name: 'Name',
                rates: {
                    billable: 'Billable',
                    settlements: 'Settlements',
                    rate: 'Rate'
                },
                lifeCycle: {
                    label: 'Life Cycle',
                    options: {
                        placeholder: 'Select option',
                        orderReceived: 'Order Received',
                        productShipped: 'Product Shipped',
                        atDispatchingLocation: 'At Dispatching Location',
                        onRoute: 'En Route',
                        complete: 'Complete'
                    }
                },
                checkboxes: {
                    orderStatus: 'Order Status',
                    cancellationReason: 'Cancellation Reason',
                    productStatus: 'Product Status',
                    operationStatus: 'Operation Status',
                    lockStatus: 'Lock Status',
                    skipRouting: 'Skip Routing',
                    skipStem: 'Skip Stem'
                },
                submit: 'Save',
                cancel: 'Cancel',
                validation: {
                    nameRequired: 'Please enter a name'
                },
                success: {
                    create: 'Successfully created status',
                    update: 'Successfully updated status'
                },
                error: 'There was an unknown error'
            },            
            fields: {
                majorProductWeight: 'Major Product Weight',
                majorProductVolume: 'Major Product Volume',
                majorProduct: 'Major Product',
                minorProductWeight: 'Minor Best Buy Product Weight',
                minorProduct: 'Minor Best Buy Product',
                totalWeight: 'Total Weight',
                totalVolume: 'Total Volume',
                totalQuantity: 'Total QTY',
                orderType: 'Order Type',
                settlementService: 'Settlement Service',
                billableService: 'Billable Service',
                substatus: 'Substatus'
            }
        }
    },
    contractorSettings: {
        error: {
            missingCompanyName: 'Company Name is required',
            missingTier: 'Tier is required',
            duplicateContractor: 'Contractor already exists',
        },
    },
    driverSettings: {
        Create: 'Create',
        Update: 'Update',
        Delete: 'Delete',
        Confirm: 'Confirm',
        Created: 'Created {0}',
        Updated: 'Updated {0}',
        Deleted: 'Deleted',
        'Type new name here': 'Type new name here',
        'Type Delivery Assignee ID': 'Type Delivery Assignee ID',
        'is not found': 'is not found',
        'Type New Contractor To Create': 'Type New Contractor To Create',
        'No Driver was found in system': 'No Driver was found in system',
    },
    driverInfo: {
        Name: 'Name',
        Company: 'Company',
        Username: 'Username',
        Password: 'Password',
        'Fleet Id': 'Fleet Id',
        'Read Only': 'Read Only',
    },
    newUserForm: {
        'Create a new user': 'Create a new user',
        'First Name': 'First Name',
        'First name is required': 'First name is required',
        'Invalid first name': 'Invalid first name',
        'Last Name': 'Last Name',
        'Last name is required': 'Last name is required',
        'Invalid last name': 'Invalid last name',
        'Store/Admin': 'Store / Admin',
        'Store is required': 'Store is required',
        Admin: 'Admin',
        'Admin is required': 'Admin is required',
        Phone: 'Phone',
        'Phone is required': 'Phone is required',
        'Type only numbers without country code': 'Type only numbers without country code',
        Email: 'Email',
        'Email is required': 'Email is required',
        'Invalid email': 'Invalid email',
        Reset: 'Reset',
        'Create user': 'Create user',
        'saved user': ' is saved with success!',
        'Update User': 'Update User',
        Close: 'Close',
    },
    notification: {
        accessDenied: 'Access denied. Please check your access level.',
        orderAssignment: 'Order Assignment',
        assigned: 'Assigned',
        unscheduled: 'Unscheduled',
        orderAssignmentSubtitle: 'Unscheduled orders have no target date yet', 
        parametersRemoved: '{{parameters}} have been removed as they are not valid for Unscheduled orders.',
        nameRequired: "Form is incomplete: Name is required",
        clientRequired: "Form is incomplete: At least one Client must be selected",
        orderTypeRequired: "Form is incomplete: At least one Order Type must be selected",
        serviceTypeRequired: "Form is incomplete: At least one Service Type must be selected",
        orderStatusRequired: "Form is incomplete: At least one Order Status must be selected",
        typeRequired: "Form is incomplete: Notification Type must be selected",
        orderAssignmentRequired: "Form is incomplete: Order Assignment must be selected",
        contentRequired: "Form is incomplete: At least one notification content (Email, SMS, or Robocall) must be filled",
        updateSuccess: "Notification updated successfully",
        createSuccess: "Notification created successfully",
        duplicateNotification: "Duplicate notification: You have notification for the selected clients, order statuses, order types, and order assignment",
        invalidEmail: "Invalid email format",
        invalidCcEmails: "One or more CC email addresses are invalid",
        invalidBccEmails: "One or more BCC email addresses are invalid",
        validSenderEmailRequired: "A valid sender email is required when email content is present",
        invalidPhoneNumber: "Invalid phone number format"
    },
    reports: {
        'Select Report Type': 'Report Type',
        'Currently Assigned Recipients': 'Currently Assigned Recipients',
        'Type email here': 'Type email here...',
        'Type Recipients Email and Hit Enter': "Type Recipient's Email and Hit Enter",
        'Reicipients list updated': 'Reicipients list updated',
    },
    Billing: {
        Hello: 'Hello',
        ViewInvoices: 'View Invoices',
        BackToOverView: 'Back To Overview',
        'Last Month Overview': 'Last Month Overview',
        'Select Month': 'Select Month',
        'Download Supporting Data': 'Download Supporting Data',
        'Download Invoice': 'Download Invoice',
        'Total Orders': 'Total Orders',
        Commingled: 'Commingled',
        Dedicated: 'Dedicated',
        orders: 'orders',
        stops: 'stops',
        Scanned: 'Scanned',
        Returns: 'Returns',
        'Driver Requests': 'Driver Requests',
    },
    forgotPassword: {
        'Reset password link was sent your email': 'Reset password link was sent your email',
        'Reset password': 'Reset password',
        'Please type your email': 'Please type your email',
        'forgot password': 'Forgot password?',
    },
    allFields: {
        actions: 'Actions',
        NumberOfDoorRemovals: 'Number Of Door Removals',
        NumberOfExtraPieces: 'Number Of Extra Pieces',
        NumberOfFridgeLineInstalls: 'Number Of Fridge Line Installs',
        NumberOfAdjustables: 'Number Of Adjustables',
        NumberOfPedInstalls: 'Number Of Ped Installs',
        NumberOfScrap: 'Number Of Scrap',
        NumberOfStacks: 'Number Of Stacks',
        NumberOfWasherDryerInstalls: 'Number Of Washer Dryer Installs',
        Charge100: 'Charge100',
        TotalHours2Man: 'Total Hours2Man',
        TotalHours3Man: 'Total Hours3Man',
        Charge50: 'Charge50',
        AddToCage: 'Add To Cage',
        DriverServices: 'Driver Services',
        ApprovedForBilling: 'Approved For Billing',
        ArchiveStatus: 'Archive Status',
        ArrivedAt: 'Arrived At',
        PlannedServices: 'Planned Services',
        Autobill: 'Autobill',
        AutoContractorBill: 'Auto Contractor Bill',
        AutoContractorBillEdited: 'Auto Contractor Bill Edited',
        Barcodes: 'Barcodes',
        BarcodesMatched: 'Barcodes Matched',
        BbCustomerEmailForSurvey: 'Bb Customer Email For Survey',
        BbCustomerSurveyComment1: 'Bb Customer Survey Comment1',
        BbCustomerSurveyComment2: 'Bb Customer Survey Comment2',
        BbGiftAmount: 'Bb Gift Amount',
        BbGiftCustomerEmail: 'Bb Gift Customer Email',
        BestBuyRobocallStatus: 'Best Buy Robocall Status',
        BestBuyRobocallTimestamp: 'Best Buy Robocall Timestamp',
        BestBuyRobocallSent: 'Best Buy Robocall Sent',
        BestBuySurveyQ1: 'Best Buy Survey Q1',
        BestBuySurveyQ2: 'Best Buy Survey Q2',
        BestBuySurveyQ3: 'Best Buy Survey Q3',
        BestBuySurveyQ4: 'Best Buy Survey Q4',
        BestBuySurveyQ5: 'Best Buy Survey Q5',
        BestBuySurveyQ6: 'Best Buy Survey Q6',
        BillingInfo: 'Billing Info',
        BillingValidated: 'Billing Validated',
        CalledCallCenter: 'Called Call Center',
        CityDistance: 'City Distance',
        Client: 'Client',
        CoastLocation: 'Coast Location',
        OrderStatus: 'Order Status',
        CompletedAt: 'Completed At',
        CompletedStops: 'Completed Stops',
        CancellationReason: 'Cancellation Reason',
        ContractorName: 'Contractor Name',
        ContractorPay: 'Contractor Pay',
        ContractorPayNotes: 'Contractor Pay Notes',
        CustomerComment: 'Customer Comment',
        CustomerName: 'Customer Name',
        CustomerRating: 'Customer Rating',
        CustomerSignature: 'Customer Signature',
        Deductions: 'Deductions',
        DeliveryAssignee: 'Delivery Assignee',
        DispatchClosed: 'Dispatch Closed',
        DispatchComments: 'Dispatch Comments',
        DispatchLog: 'Dispatch Log',
        DistributionZone: 'Distribution Zone',
        Driver: 'Driver',
        DriverAttachments: 'Driver Attachments',
        DriverNotes: 'Driver Notes',
        DriverTrackingLink: 'Driver Tracking Link',
        DropoffAddress: 'Dropoff Address',
        DropoffApt: 'Dropoff Apt',
        DropoffCityTown: 'Dropoff City Town',
        DropoffMapUrl: 'Dropoff Google Map Url',
        DropoffPostalCode: 'Dropoff Postal Code',
        DropoffStDr: 'Dropoff St Dr',
        DropoffUnit: 'Dropoff Unit',
        Email: 'Email',
        EndWindow: 'End Window',
        EtaLink: 'Eta Link',
        NumberOfExchanges: 'Number Of Exchanges',
        ExtraAttachments: 'Extra Attachments',
        GeoLocation: 'Geo Location',
        HourlyWork: 'Hourly Work',
        Invoice: 'Invoice',
        CoastInvType: 'Coast Inv Type',
        IsMetroCubeOrigin: 'Is Metro Cube Origin',
        KmDriven: 'Km Driven',
        LastArchived: 'Last Archived',
        LastAutobilled: 'Last Autobilled',
        LastMetroUpdate: 'Last Metro Update',
        LastTookanSync: 'Last Tookan Sync',
        Latitude: 'Latitude',
        Liabilities: 'Liabilities',
        LinkedOrder: 'Linked Order',
        LocationAccuracy: 'Location Accuracy',
        Longitude: 'Longitude',
        MetroNeedUpdate: 'Metro Need Update',
        NumberPastDoor: 'Number Past Door',
        NumberPriorToDoor: 'Number Prior To Door',
        NewOrderAttachments: 'New Order Attachments',
        NoCharge: 'No Charge',
        OpsBilling: 'Ops Billing',
        OpsMargin: 'Ops Margin',
        OutOfTown: 'Out Of Town',
        OverridePickupApt: 'Override Pickup Apt',
        OverridePickupCityTown: 'Override Pickup City Town',
        OverridePickupPostalCode: 'Override Pickup Postal Code',
        OverridePickupStDr: 'Override Pickup St Dr',
        OverridePickupUnit: 'Override Pickup Unit',
        Phone1: 'Phone1',
        Phone2: 'Phone2',
        ClientSubUnit: 'Client Sub Unit',
        PickupAddress: 'Pickup Address',
        PickupApt: 'Pickup Apt',
        PickupByLinehaul: 'Pickup By Linehaul',
        PickupCityTown: 'Pickup City Town',
        PickupMapUrl: 'Pickup Google Map Url',
        PickupPostalCode: 'Pickup Postal Code',
        PickupStDr: 'Pickup St Dr',
        PickupUnit: 'Pickup Unit',
        OrderType: 'Order Type',
        PickupCityDistance: 'Pickup City Distance',
        PickupGeoLocation: 'Pickup Geo Location',
        PickupLatitude: 'Pickup Latitude',
        PickupLocationAccuracy: 'Pickup Location Accuracy',
        PickupLongitude: 'Pickup Longitude',
        PlannedStops: 'Planned Stops',
        Pod: 'Pod',
        ProductCount: 'Product Count',
        ProductJson: 'Product Json',
        Products: 'Products',
        ProductsArrival: 'Products Arrival',
        PushTime: 'Push Time',
        DriverPushStatus: 'Driver Push Status',
        ReceivedInWh: 'Received In Wh',
        Region: 'Region',
        RequestedDeliveryWindow: 'Requested Delivery Window',
        ScannedBarcodes: 'Scanned Barcodes',
        ServiceTime: 'Service Time',
        ShippedOut: 'Shipped Out',
        Skus: 'Skus',
        StairsOver3rdFloor: 'Stairs Over3rd Floor',
        StartWindow: 'Start Window',
        StartedAt: 'Started At',
        OpsStatuses: 'Ops Statuses',
        Stem: 'Stem',
        StemKms: 'Stem Kms',
        Store: 'Store',
        Swamper: 'Swamper',
        SwamperEnd: 'Swamper End',
        SwamperStart: 'Swamper Start',
        TextMsgLogs: 'Text Msg Logs',
        TimeOffset: 'Time Offset',
        TookanStatus: 'Tookan Status',
        TookanId: 'Tookan Id',
        Vehicle: 'Vehicle',
        UniqueOrderId: 'Unique Order Id',
        User: 'User',
        VaultId: 'Vault Id',
        Volume: 'Volume',
        WhirlpoolLoadId: 'Whirlpool Load Id',
        AutoBillEdited: 'Auto Bill Edited',
        AutoBillComments: 'Auto Bill Comments',
        ContractorBillingValidated: 'Contractor Billing Validated',
        FileUploadsDictionary: 'File Uploads Dictionary',
        _CreatedTimestamp: 'Created Timestamp',
        _UpdatedTimestamp: 'Updated Timestamp',
        _ImportedTimestamp: 'Imported Timestamp',
        _Operation: 'Operation',
    },
    portal: {
        'Main Portal': 'Main Portal',
        'TV Portal': 'TV Portal',
        'Same Day Portal': 'Same Day Portal',
    },
    contactless: {
        'Type and select zone to map clients': 'Type and select zone to map clients',
        'not exist': 'not exist',
        'Currently Mapped Clients': 'Currently Mapped Clients',
        Updated: 'Updated contactless delivery settings for {0}',
    },
    orderStatusSettings: {
        success: {
            statusDeleted: 'Status is deleted successfully',
        },
        warning: {
            cannotDeleteStatus: "You can't delete the default status",
            error: 'Something went wrong. Please contact Shyftbase.',
        },
        tooltip: {
            billableSettlementRate: 'Billing and settlements rates, used by the automated billing module',
            ignoreStem: 'Toggle to apply stem calcaultions',
            ignoreOptimizer: 'If toggled off, the routing engine will ignore orders with this status',
            shouldLock: 'If toggled on, the order will be locked and cannot be updated',
            lifeCycle: 'Define the stage of the delivery life cycle',
        },
    },
    clientSettings: {
        'Create a new client': 'Create a new client',
        activate: 'Activate',
        deactivate: 'Deactivate',
        activated: 'activated',
        deactivated: 'deactivated',
        'client name is required': 'client name is required',
        'Include in Inventory': 'Include in Inventory',
        'Client Name': 'Client Name',
        updateSuccess: 'Client updated successfully',
        'Successfully created': 'Successfully created',
        'Client already exists': 'Client already exists',
        'No region found': 'No region found',
        'Region is required': 'Region is required',
        'Type to search region': 'Type to search region',
        Inventory: 'Inventory',
        'Reverse Logistics': 'Reverse Logistics',
        'Include in Reverse Logistics': 'Include in Reverse Logistics',
        'Send Survey': 'Send Survey',
        Yes: 'Yes',
        No: 'No',
        'Billing Code': 'Billing Code',
        'Default address': 'Default address',
        'Save changes': 'Save changes',
        'Upload Survey Logo': 'Upload Survey Logo',
        'Remove Survey Logo': 'Remove Survey Logo',
    },
    ikeaDriverSetting: {
        'Select type to proceed': 'Select type to proceed',
        loading: 'loading...',
        drivers: 'drivers',
        contractors: 'contractors',
        'Create New': 'Create New',
        Update: 'Update',
        Delete: 'Delete',
        Region: 'Region',
        ID: 'ID',
        Name: 'Name',
        Company: 'Company',
        'Company Name': 'Company Name',
        Active: 'Active',
        Submit: 'Submit',
        Cancel: 'Cancel',
        'successfully updated': 'successfully updated',
        'successfully removed': 'successfully removed',
        'No options matching the keyword': 'No options matching the keyword',
        Select: 'Select',
    },
    dateRegion: {
        changeParameters: 'Change Parameters',
        dateField: 'Select Date Field',
        dateRange: 'Select Shipment Date Range',
        Records: 'Records',
        firebase10Limit: 'Select up to 10 or all',
        selectRequiredFields: 'Please select date field, client(s) and terminal(s)',
        orderCountToCheck: {
            one: '{{needToCheckDispatch}} order needs attention',
            other: '{{needToCheckDispatch}} orders need attention',
        },
        buttons: {
            addUpload: 'Add/Upload',
            dedicatedOrder: 'Dedicated Order',
            order: 'Order',
            upload: 'Upload',
        },
        supplyChain: {
            status: {
                pending: 'Pending',
                processing: 'Processing',
                shipped: 'Shipped',
                delivered: 'Delivered',
            },
            inventory: {
                low: 'Low Stock',
                outOfStock: 'Out of Stock',
                available: 'In Stock',
            },
        },
        customerShipmentNotification: {
            title: 'New Customer Shipments',
            message: 'Customers have placed shipments from the portal',
            info: 'Each shipment typically includes both pickup and delivery',
            closeAriaLabel: 'Close notification',
        },
        liveConnectNotification: {
            title: 'Right-Click to Manage Orders',
            message: 'Right-click on any order row to approve or reject orders quickly.',
            info: 'Use the context menu for quick actions',
            closeAriaLabel: 'Close notification',
        },
    },
    user: {
        deleteUserSuccessMsg: 'User was removed successfully.',
        removUserDialogTitle: 'Remove User',
        removUserDialogMsg: `You are about to delete {{email}}. Are you sure?`,
    },
    generics: {
        reset: 'Reset',
        yes: 'Yes',
        no: 'No',
        ok: 'Ok',
        cancel: 'Cancel',
        save: 'Save',
        close: 'Close',
        delete: 'Delete',
        edit: 'Edit',
        add: 'Add',
        remove: 'Remove',
        update: 'Update',
        create: 'Create',
        search: 'Search',
        filter: 'Filter',
        volume: 'Volume',
        weight: 'Weight',
        submit: 'Submit',
    },
    productDetails: {
        Destination: 'Destination',
        ReverseLogisticsBarcode: 'Reverse Barcode',
        ServiceTime: 'Service Time',
        shyftCodeTooltip: 'Shyftbase generated barcode',
        Barcode: 'Barcode',
        Shyftcode: 'Shyftcode',
        BolNumber: 'Latest BoL',
        Comment: 'Comment',
        Mfr: 'Manufacturer',
        Model: 'Model',
        OriginHub: 'OriginHub',
        Product: 'Product',
        Quantity: 'Quantity',
        Serial: 'Serial',
        Sku: 'Sku',
        Status: 'Status',
        Volume: 'Volume',
        Weight: 'Weight',
        Id: 'Id',
        PoNumber: 'PO Number',
        PickupByLinehaul: 'Picked UP By Linehaul',
        BolHistory: 'BOL History',
        ShippingDate: 'Shipping Date',
        BolCreatedBy: 'Created By',
        BolOriginHub: 'Origin Hub',
        BolDestinationHub: 'Destination Hub',
    },
    orderTable: {
        dateRange: {
            copyParameters: 'Copy Parameters',
            copySuccess: 'Copied!',
        },
        filterDetail: {
            resetFilters: 'Reset Filters',
            currentFilters: 'Current Filters',
            noFiltersApplied: 'No filters applied',
        },
        updateNotification: {
            info: 'updated following orders',
            warning:
                'Please re-select the order if you were about to edit one of them via edit window or quick action.',
        },
        TimeLockedStatus: {
            warning: 'The delivery date of this order is locked. You cannot edit it.',
        },
        VehicleLockedStatus: {
            warning: 'The vehicle of this order is locked. You cannot edit it.',
            warningInBulk: 'Some of selected orders have locked vehicle status. You cannot edit it.',
        },
        contextMenu: {
            tooltip: {
                billingToggleBoth: 'Toggle billing and settlement statuses',
                retriggerBillingModule: 'Recalculate billing and settlement values',
                geocodeOneAtAtime: 'Re-geocode order(s). This will retrigger the billing module.',
            },
        },
    },
    help: {
        shyftbaseGuides: 'Shyftbase Guides',
        searchVideoGuides: 'Search video guides by topic, title, or keyword',
        dispatch: 'Dispatch',
        routing: 'Routing',
        network: 'Network',
        admin: 'Admin',
        driver: 'Driver',
        inventory: 'Inventory',
        billingModule: 'Billing Module',
        howToCreateOrders: 'How to create orders',
        howToDispatchOrders: 'How to dispatch orders to drivers',
        howToRescheduleOrders: 'How to reschedule orders',
        howToPlaceRoboCalls: 'How to place robocalls',
        howToSearchForAnything: 'How to search for anything',
        howToPrintReportsInvoicesAndLabels: 'How to print reports, invoices, and labels',
        howToApproveOrdersFromStores: 'How to approve orders from stores',
        howToCreateViewsOrShareViews: 'How to create views or share views',
        howToUseOrderTableFiltersGroupingsAndSorting: 'How to use order table filters, groupings, and sorting',
    },
    asset: {
        messages: {
            updateSuccess: 'Asset updated successfully',
            createSuccess: 'Asset created successfully',
            error: 'Something went wrong. Please try again',
            deleteSuccess: 'Asset deleted successfully',
            errorDelete: 'Something went wrong. Please try again',
        },
    },
    toggleAIAssistant: 'Toggle AI Assistant',
    profileSetup: {
        title: 'Set Up Your Profile',
        fullName: {
            label: 'Full Name',
            placeholder: 'Enter your full name'
        },
        phoneNumber: {
            label: 'Phone Number',
            placeholder: 'Enter your phone number'
        },
        email: {
            label: 'Email',
            placeholder: 'Enter your email'
        },
        logoFile: 'Logo File',
        buttons: {
            save: 'Save Profile',
            cancel: 'Cancel'
        },
        messages: {
            incomplete: 'Form is incomplete!',
            success: 'Profile updated successfully',
            loadError: 'Failed to load profile data'
        }
    },
    dispatch: {
        tooSmall: 'Please use a larger screen (at least 1024px wide) for the Dispatch board.',
        live: 'Live',
        clearSelection: 'Clear selection',
        card: {
            unassigned: 'Unassigned',
            openDetails: 'Open details',
            reassignVehicle: 'Reassign vehicle',
            pushToDriver: 'Push to driver',
        },
        column: {
            noOrders: 'No orders',
        },
        bulk: {
            selected: '{{count}} order selected',
            selected_plural: '{{count}} orders selected',
            reassignVehicle: 'Reassign vehicle',
            pushToDrivers: 'Push to drivers',
            pushing: 'Pushing…',
            clear: 'Clear',
        },
        filters: {
            title: 'Filters',
            apply: 'Apply',
            cancel: 'Cancel',
            clearAll: 'Clear all',
        },
    },
}
